import React ,{useContext}from 'react';
import { Link } from 'react-router-dom'
import useFeatureChecker, { AllowedFeature, DeniedFeature } from '../shared/FeatureChecker.js';
import TableList from '../shared/TableList.js';
import translateAlert from './translate_alert.js';
import translateType from './translate_type.js';
import { DestroyButton } from '../shared/Buttons.js';
import { CurrentCompanyContext } from '../../App.js';


export default   function NotificationTable({ notifications,refetch }) {
  const CheckFeatures = useFeatureChecker()
  const currentCompany = useContext(CurrentCompanyContext)
  if(!notifications.length) {
    return <div className="text-center text-muted py-4 my-4">No hay personas para notificar</div>
  }

  return (
    <TableList>
      <TableList.Header>
        <TableList.HeaderItem value="Usuario" />
        <TableList.HeaderItem value="Tipo"  />
        <TableList.HeaderItem value="Notificación"  />
        <TableList.HeaderItem value="Alerta"/>
        <TableList.HeaderItem value=" "/>
      </TableList.Header>

      <TableList.Body>
        {
          notifications.map(item => (
            <TableList.Row key={item.type+item.notification}>
              <CheckFeatures feature='DETAIL_USER'>
                <AllowedFeature>
                  <TableList.Column>
                    <Link to={"/members/" + item.user_id}> {item.name} </Link>
                  </TableList.Column>
                </AllowedFeature>
                <DeniedFeature>
                  <TableList.Column>
                    {item.name}
                  </TableList.Column>
                </DeniedFeature>
              </CheckFeatures>
              <TableList.Column value={translateType(item.notification_type)}/>
              <TableList.Column value={item.notification}/>
              <TableList.Column value={translateAlert(item.type)}/>
              <TableList.Column>
                <CheckFeatures feature="DESTROY_NOTIFICATION">
                  <DestroyButton
                    label="Eliminar notificación"
                    confirmMessage="¿Está seguro que desea eliminar la notificación?"
                    successMessage="La notificación eliminada correctamente"
                    errorMessage={"La notificación no ha podido ser eliminada"}
                    deletePath={`notifications/${item.id}?CompanyId=${currentCompany.id}`}
                    refetch={refetch}
                  />
                </CheckFeatures>
              </TableList.Column>
            </TableList.Row>
          ))
        }
      </TableList.Body>
    </TableList>
  )
}
